import { render, staticRenderFns } from "./program-view.vue?vue&type=template&id=5ca85b1f&"
import script from "./program-view.vue?vue&type=script&lang=js&"
export * from "./program-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports